export enum chargesListTypes {
    GET_CHARGESLIST = '@@CHARGESLIST/GET_CHARGESLIST',
    GET_CHARGESLIST_SUCCESS = '@@CHARGESLIST/GET_CHARGESLIST_SUCCESS',
    GET_CHARGESLIST_FAIL = '@@CHARGESLIST/GET_CHARGESLIST_FAIL',
  
  }
  